import countryList from "react-select-country-list";
import { country } from "../constants";

export const filteringCountry = () => {
  let countries = countryList().getData();
  let countryLabel = [];
  countries.forEach((item) =>
    Object.keys(item).forEach(function (property) {
      country.forEach((_item) => {
        if (
          _item.continent !== "AUSTRALASIA/PACIFIC" &&
          _item.continent !== "AFRICA"
        ) {
          _item.regions.forEach((region) => {
            region.countries.forEach((country) => {
              if (item[property].toUpperCase() === country) {
                countryLabel.push({
                  value: item[property],
                  label: item[property],
                });
              }
            });
          });
        } else {
          _item.countries.forEach((country) => {
            if (item[property].toUpperCase() === country) {
              countryLabel.push({
                value: item[property],
                label: item[property],
              });
            }
          });
        }
      });
    })
  );
  return countryLabel;
};
